import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import axiosPrivate from "../../services/axios/axiosPrivate";

export const fetchAllActiveEmp = createAsyncThunk(
    'getAllActiveEmp/fetchAllActiveEmp',
    async (_, { rejectWithValue }) => {
        try {
            const url = api.credentials.allActiveEmp;
            const response = await axiosPrivate.get(url)
            return response.data.data;
        } catch (err) {
            return rejectWithValue(err?.response?.data?.message || "Unable to connect to server");
        }
    }
)

const getAllActiveEmpSlice = createSlice({
    name: 'activeEmp',
    initialState: {
        activeEmp: [],
        status: 'idle',
        loading: false,
        error: null
    },
    reducers: {},
    extraReducers: (builders) => {
        builders
            .addCase(fetchAllActiveEmp.pending,
                (state) => {
                    state.status = 'loading';
                    state.loading = true;
                    state.error = null;
                })
            .addCase(fetchAllActiveEmp.fulfilled,
                (state, action) => {
                    state.status = 'succeeded';
                    state.loading = false;
                    state.activeEmp = action.payload.map(emp => {
                        const rawName = typeof emp === 'string' ? emp : (emp.name || "");

                        const cleanName = rawName
                            .replace(/_/g, ' ')
                            .replace(/[^a-zA-Z0-9 ]/g, '')
                            .replace(/\s+/g, ' ')
                            .trim();

                        return typeof emp === 'string' ? cleanName : { ...emp, name: cleanName };
                    });
                })
            .addCase(fetchAllActiveEmp.rejected,
                (state, action) => {
                    state.status = 'failed';
                    state.loading = false;
                    state.error = action.payload;
                }
            )
    }
})

export default getAllActiveEmpSlice.reducer;